import {  authAC, balanceAC, fileAC, providerAC } from "./action-creators";
import store from "./store";

export const clearStore = async (): Promise<void> => {
  await store.dispatch(authAC.setAuthData({}));
  await store.dispatch(providerAC.setProvider({}));
  await store.dispatch(
    balanceAC.setBalanceData({
      email: null,
      publicKey: null,
      allTransactions:[]
    })
  );
  await store.dispatch(fileAC.setFileData([]));

};
